import React from 'react';
import { Layout } from '../components/layout/Layout';
import { HeroSection } from '../components/sections/HeroSection';
import { NarrativeSection } from '../components/sections/NarrativeSection';
import { PillarsSection } from '../components/sections/PillarsSection';
import { MapSection } from '../components/sections/MapSection';
import { RussophonyDaySection } from '../components/sections/RussophonyDaySection';
import { ThinkTankSection } from '../components/sections/ThinkTankSection';
import { NewsletterSection } from '../components/sections/NewsletterSection';
import { WhatsAppSection } from '../components/sections/WhatsAppSection';

const HomePage = () => {
  return (
    <Layout>
      <HeroSection />
      <NarrativeSection />
      <PillarsSection />
      <RussophonyDaySection />
      <WhatsAppSection />
      <MapSection />
      <ThinkTankSection />
      <NewsletterSection />
    </Layout>
  );
};

export default HomePage;
